import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";

const EventCategoryImages = {
  1: { url: "/static/images/eventIcons/ambulance.svg", name: "ambulance" },
  2: { url: "/static/images/eventIcons/hospital.svg", name: "hospital" },
  3: { url: "/static/images/eventIcons/globe.svg", name: "globe" },
};

const EventActionType = () => {
  const { eventCategory } = useEventStore();
  if (!eventCategory) return null;
  return (
    <div className={styles.ActionType}>
      <img
        src={EventCategoryImages[eventCategory?.id]?.url}
        alt={EventCategoryImages[eventCategory?.id]?.name}
      />
      <span>{eventCategory.name}</span>
    </div>
  );
};

export default EventActionType;
